module.exports = __webpack_public_path__ + "static/img/quark--pagecover-image.dd4b29c8.png";